





























































































import {Component, Vue, Inject, Emit, Prop} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import {API_GetSmsCaptcha, API_Register} from "@/api/login";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};


const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
}
const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
}
const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a'
}

@Component({
    components: {}
})
export default class userDetailForm extends AbpBase {
    @Prop({type:Object,default:()=>{return {}}})
    provideInfo:any;

    form: any;
    formItemLayout = formItemLayout;

    state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
    }

    get passwordLevelClass () {
        return levelClass[this.state.passwordLevel]
    }
    get passwordLevelName () {
        return levelNames[this.state.passwordLevel]
    }
    get passwordLevelColor () {
        return levelColor[this.state.passwordLevel]
    }

    handlePasswordInputClick () {
        this.state.passwordLevelChecked = true
    }

    beforeCreate() {
        this.form = this.$form.createForm(this);
    }

    handlePasswordLevel (rule, value, callback) {
        let level = 0

        // 判断这个字符串中有没有数字
        if (/[0-9]/.test(value)) {
            level++
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(value)) {
            level++
        }
        // 判断字符串中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(value)) {
            level++
        }

        if(value.length<6){
            level = 0;
        }

        this.state.passwordLevel = level
        this.state.percent = level * 30
        if (level >= 2) {
            if (level >= 3) {
                this.state.percent = 100
            }
            callback()
        } else {
            if (level === 0) {
                this.state.percent = 10
            }
            callback(new Error('密码强度不够'))
        }
    }

    handlePasswordCheck (rule, value, callback) {
        const password = this.form.getFieldValue('password')
        console.log('value', value)
        if (value === undefined) {
            callback(new Error('请输入密码'))
        }
        if (value && password && value.trim() !== password.trim()) {
            callback(new Error('两次密码不一致'))
        }
        callback()
    }

    handleSubmit(e) {
        var self = this;
        e.preventDefault();
        self.form.validateFields(async (err, values) => {
            if (err) {
                return;
            }

            let reqData = values;
            reqData = _.extend(reqData,this.provideInfo);

            API_Register(values).then((res)=>{
                let {data,errno,message} = res.data;
                if(errno!=0){
                    this.$message.info(message);
                    return;
                }

                this.$message.success("注册成功!");
                this.registerEnd();
            })

        });
    }

    mounted(){
        console.log('uuid',this.provideInfo);
    }

    @Emit("registerEnd")
    registerEnd(){
        return 1
    }


}
